<template>
  <q-page padding>
    <div
        v-if="loadingMission"
        class="col items-center justify-center q-pa-lg q-gutter-md"
        >
        <div class="row justify-center">
          <q-spinner size="3em"  color="primary" />
        </div>
    </div>
    <MissionForm 
              v-model:mission="mission"
              button-label="Kopieren"
              @update:date="updateDate"
              @onSubmit="copy"
    >
    <q-checkbox
        :label="`Teams (${mission.team_set.length}) kopieren`"
        v-model="copyTeams"
        v-if="mission.team_set.length"
        />
    </MissionForm>
  </q-page>
</template>

<script>
  import MissionForm from '@/components/MissionForm.vue'
  import { getMission, createMission } from '@/services/Missions.js'
  import { getTeamsByMission, createTeam, createPosition } from '@/services/Teams.js'
  import { Notify } from 'quasar'
  import { updateMissionDate } from '@/utils/useDateUtils.js'
  import { apiErrorHandler } from '@/utils/apiErrorHandler.js'

  export default {
    components: { MissionForm },
    data() { 
      return {
        mission: {
          title: "",
          excerpt: "",
          description: "",
          start_date: "",
          end_date: "",
          team_set: []
        },
        teams: [],
        copyTeams: true,
        loadingMission: true
      } 
    },
    mounted() {
      const loadTeams = (mission) => {
        if (!mission.team_set.length) return null
        return getTeamsByMission(this.$route.params.id)
          .then(teams => { this.teams = teams; return null })
          .catch(apiErrorHandler("[MissionCopy] Teams laden", { silent: true }))
      }
      getMission(this.$route.params.id)
        .then(response => {
          this.mission = response
          return loadTeams(response)
        })
        .then(() => { this.loadingMission = false })
        .catch(apiErrorHandler("[MissionCopy] Mission laden"))
    },
    methods: {
      async copy() {
        let mission = { ...this.mission, team_set: [] }
        mission = await createMission(mission)
        if (this.copyTeams && this.teams.length) {
          const proms = this.teams.map(team => this.copyTeam(team, mission.id))
          await Promise.all(proms)
        }
        Notify.create({
          message: "Termin kopiert",
          type: "positive"
        })
        this.switchToMission(mission.id)
      },
      async copyTeam(team, missionId) {
        const newTeam = await createTeam(team.name, missionId)
        const proms = team.positions.map(position =>
          createPosition(newTeam.id, position.role.id, position.optional)
        )
        await Promise.all(proms)
      },
      switchToMission(id) {
          this.$router.back()
          this.$router.replace(`/missions/${id}`)
      },
      updateDate(d) {
        updateMissionDate(this.mission, d)
      }
    }
  }
</script>
